import styled from "styled-components";
import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { red } from "../../styles";
import AwardCard from "./AwardCard";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Page = styled.main`
  text-align: left;
  color: #3c3b3b;
`;

const SectionContent = styled.div``;

const Panel = styled.div`
  text-align: left;
`;

const Loading = styled.div`
  margin: 30px auto;
  font-size: 40px;
  text-align: center;
  color: ${red};
`;

function WebpageRecipients() {
  //const { year } = useParams();
  const year = "2026";
  const [awardeeList, setAwardeeList] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const topRef = useRef(null);

  useEffect(() => {
    fetch(
      `https://sm-v2-functions-aahmgfg3bgayfjfw.eastus-01.azurewebsites.net/api/getEndowmentRecipientsWebpage?year=${year}`
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`API error: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const sortedList = data.reduce((acc, awardee) => {
          const fundName = awardee.endowment_fund || "Other";

          if (acc[fundName]) {
            acc[fundName].awardeeList.push(awardee);
          } else {
            acc[fundName] = {
              name: fundName,
              awardeeList: [awardee],
            };
          }

          return acc;
        }, {});

        for (let awardId in sortedList) {
          sortedList[awardId].awardeeList.sort((a, b) => {
            return (a.last_name || "").localeCompare(b.last_name || "");
          });
        }

        setAwardeeList(sortedList);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setError("Error fetching data");
        setIsLoading(false);
      });
  }, [year]);

  if (isLoading) {
    return (
      <Page>
        <Loading>
          <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
        </Loading>
      </Page>
    );
  }

  if (error) {
    return (
      <span className="row">
        <span className="alert alert-danger" role="alert">
          {error}
        </span>
        <br />
      </span>
    );
  }

  return (
    <SectionContent>
      <div ref={topRef} />

      <h1
        style={{
          textAlign: "left",
          color: "rgb(0, 55, 103)",
          fontSize: "32px",
          fontWeight: "bold",
        }}
      >
        {year} Endowment Awardees
      </h1>

      <p style={{ textAlign: "left" }}>
        The SOT Endowment Fund is a family of funds that support SOT programs
        and members. Many of the funds sponsor awards designed to encourage,
        assist, and highlight toxicology research and toxicologists.
      </p>

      <Panel>
        <div className="row">
          {Object.keys(awardeeList).length > 0 &&
            Object.keys(awardeeList)
              .sort()
              .map((awardId, index) => (
                <AwardCard
                  key={`fund-${year}-${index}`}
                  year={year}
                  awardName={awardeeList[awardId].name}
                  awardeeList={awardeeList[awardId].awardeeList}
                />
              ))}
        </div>
      </Panel>
    </SectionContent>
  );
}

export default WebpageRecipients;
